import React, { forwardRef } from 'react';

import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

const Button = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: -1.25rem;
  transform: translateY(-50%);
`;

interface DropdownButtonProps {
  onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
  isExpanded: boolean;
}

const NavMenuControlButton = forwardRef<HTMLButtonElement, DropdownButtonProps>(
  ({ onKeyDown, isExpanded = false }, ref) => (
    <Button onKeyDown={onKeyDown} aria-expanded={isExpanded} data-testid='nav-menu-control-button-test-id' ref={ref}>
      <FontAwesomeIcon size='xs' icon={faChevronDown} />
    </Button>
  )
);

export default NavMenuControlButton;
